import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

// Agency Statements, for holders of the `agency-statements` grant. The API enforces the agency side of
// it per branch, so this guard is about not showing someone a page whose every call would 403; it is
// not the security boundary. Under "login as" it follows the impersonated user's grant.
const AgencyStatementsRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canViewAgencyStatements, isLoading, rolesUnknown } = useUserRole();

  // The profile lookup failed, so we don't know whether access was granted — say so rather than
  // redirect, which would read as a denial to someone who does have it.
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!canViewAgencyStatements) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AgencyStatementsRoute;
